module.exports = __webpack_public_path__ + "assets/img/fr-a75af78b.png";